﻿const enum BodyType {
	none,
	text,
	json,
	blob,
	bytes,
	formData,
	arrayBuffer,
	// uint8Array
}

function checkBodyType(requested: BodyType, actual: BodyType) {
	if (requested == actual) {
		return;
	}

	throw new Error(`The response body [${actual}] is not of the requested type [${requested}].`);
}

export class ProxyResponse implements Response {
	private _response: Response;
	private _bodyType: BodyType;

	constructor(response: Response) {
		this._response = response;
		this._bodyType = BodyType.none;
		this._body = response.body;
	}

	private _body: any;

	get body(): ReadableStream<Uint8Array<ArrayBuffer>> | null {
		return this._body;
	}

	get url(): string {
		return this._response.url;
	}

	get type(): ResponseType {
		return this._response.type;
	}

	get statusText(): string {
		return this._response.statusText;
	}

	get status(): number {
		return this._response.status;
	}

	get redirected(): boolean {
		return this._response.redirected;
	}

	get ok(): boolean {
		return this._response.ok;
	}

	get headers(): Headers {
		return this._response.headers;
	}

	get bodyUsed(): boolean {
		return this._response.bodyUsed;
	}

	clone(): Response {
		return this._response.clone();
	}

	async arrayBuffer(): Promise<ArrayBuffer> {
		return this._getCachedBody(BodyType.arrayBuffer, () => this._response.arrayBuffer());
	}

	async blob(): Promise<Blob> {
		return this._getCachedBody(BodyType.blob, () => this._response.blob());
	}

	async bytes(): Promise<Uint8Array<ArrayBuffer>> {
		return this._getCachedBody(BodyType.bytes, () => this._response.bytes());
	}

	async formData(): Promise<FormData> {
		return this._getCachedBody(BodyType.formData, () => this._response.formData());
	}

	async json(): Promise<any> {
		return this._getCachedBody(BodyType.json, () => this._response.json());
	}

	async text(): Promise<string> {
		return this._getCachedBody(BodyType.text, () => this._response.text());
	}

	private _getCachedBody<T>(requested: BodyType, factory: () => Promise<T>): Promise<T> {
		if (this._bodyType == BodyType.none) {
			this._bodyType = requested;
			return this._body = factory();
		}

		checkBodyType(requested, this._bodyType);
		return this._body;
	}
}
